import * as React from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect.es.js';

function useDynamicCallback(callback) {
  var ref = React.useRef(callback);
  useIsomorphicLayoutEffect(function () {
    ref.current = callback;
  }, [callback]);
  return React.useCallback(function () {
    return ref.current.apply(ref, arguments);
  }, []);
}

export { useDynamicCallback };